import { Component, useRef } from 'react';
import { Accordion, Grid, Icon, Segment } from 'semantic-ui-react';
import { useWikiSearch } from '../WikiSearchContext';
import useHighlightMatches from '../useHighlightMatches';

class ResourceContentClass extends Component {
  state = { activeIndex: [0, 1, 2, 3, 4] };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;

    const newIndex = activeIndex.includes(index)
      ? activeIndex.filter((i) => i !== index)
      : [...activeIndex, index];

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const { contentRef } = this.props;

    return (
      <div ref={contentRef}>
        <Grid id="detailed-segment">
          <Grid.Column width={16}>
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Accordion styled fluid id="segment" exclusive={false}>
                  <Accordion.Title
                    active={activeIndex.includes(0)}
                    index={0}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Provider Resources
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(0)}>
                    <ul>
                      <li>
                        <a href="https://drive.google.com/open?id=1tIlsYodbl1_Po_Tgl0VHzi2wjmRmuZgRX8ETs7kiVfE">
                          Orientation Presentation
                        </a>
                      </li>
                      <li>
                        <a href="https://www.hhs.gov/hipaa/for-professionals/privacy/guidance/access/index.html">
                          Individuals' Right under HIPAA to Access their Health
                          Information
                        </a>
                      </li>
                      <li>
                        <a href="https://firebasestorage.googleapis.com/v0/b/reactportal-5992d.appspot.com/o/BHP%20Documentation%20Guide.pdf?alt=media&token=baaeaeae-502c-4202-a696-86a2afe18ecd">
                          BHP Documentation Guide
                        </a>
                      </li>
                    </ul>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(1)}
                    index={1}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Training
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(1)}>
                    <ul>
                      <li>
                        <a href="https://www.maine.gov/dhhs/ocfs/documents/MRT_Online_APR2018.pdf">
                          Mandated Reporting
                        </a>
                      </li>
                      <li>
                        <a href="https://firebasestorage.googleapis.com/v0/b/reactportal-225702.appspot.com/o/Getting%20Started%20with%20Relias.pdf?alt=media&token=6ab3f5b8-9f59-4613-b98e-be51daa6dad7">
                          Getting Started with Relias Guide
                        </a>
                      </li>
                      <li>
                        <a href="http://reactbh.training.reliaslearning.com/">
                          Relias Learning Systems - Login Page
                        </a>
                      </li>
                      <li>
                        <a href="https://www.udemy.com/share/101DT6B0MYdF9XQH4=/">
                          Providing Trauma Informed Care (paid course, contact
                          us if interested)
                        </a>
                      </li>
                      <li>
                        <a href="https://drive.google.com/file/d/1p1RMCBsjtKnctvU_WKcIQxd1mS0k28hw/view?usp=sharing">
                          BHP Certification - Student Manual
                        </a>
                      </li>
                    </ul>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(2)}
                    index={2}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Autism
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(2)}>
                    <ul>
                      <li>
                        <a href="https://www.youtube.com/watch?v=0o1PXeFEcL0">
                          Autism: An evolutionary perspective, Professor Simon
                          Baron-Cohen
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youtube.com/watch?v=IA4tE3_2qmI&t=18s">
                          Temple Grandin - "The Autistic Brain: Thinking Across
                          the Spectrum"
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youtube.com/watch?v=9xT08InDP4E">
                          Managing Problem Behaviors in Children with Autism and
                          Developmental Disabilities
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youtube.com/watch?v=_nOgfA5Buv0">
                          Autism Spectrum Disorder in Infants and Toddlers
                        </a>
                      </li>
                      <li>
                        <a href="https://www.coursera.org/learn/autism-spectrum-disorder">
                          Coursera - Autism Spectrum Disorder
                        </a>
                      </li>
                    </ul>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(3)}
                    index={3}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Services
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(3)}>
                    <ul>
                      <li>
                        <a href="https://www.maine.gov/dhhs/ocfs/cbhs/documents/ME-OCFS-CBHS-Assessment-Final-Report.pdf">
                          ME-OCFS-CBHS-Assessment-Final-Report
                        </a>
                      </li>
                      <li>
                        <a href="https://www.maine.gov/dhhs/ocfs/cbhs/documents/5-2-18Youth%20Transition.pdf">
                          High School & Beyond - A Guide to Transition Services
                        </a>
                      </li>
                    </ul>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(4)}
                    index={4}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Miscellaneous
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(4)}>
                    <ul>
                      <li>
                        <a href="https://www.youtube.com/watch?v=NNnIGh9g6fA">
                          Human Behavioral Biology - Robert Sapolsky
                        </a>
                      </li>
                      <li>
                        <a href="https://www.coursera.org/learn/introduction-psychology">
                          Coursera - Introduction to Psychology
                        </a>
                      </li>
                    </ul>
                  </Accordion.Content>
                </Accordion>
              </Segment>
            </Segment.Group>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const ResourceContent = (props) => {
  const { searchTerm } = useWikiSearch();
  const contentRef = useRef(null);
  useHighlightMatches(contentRef);

  return (
    <ResourceContentClass
      {...props}
      searchTerm={searchTerm}
      contentRef={contentRef}
    />
  );
};

export default ResourceContent;
